module.exports = __webpack_public_path__ + "media/music/saw_lead_2-5bec584d.mp3";